import axios from 'axios';

const optOutApi = axios.create({
  baseURL: `/course-evaluations/student/opt-out`,
});

export const createOrUpdateOptOut = async (hashedStudentId, termId, brandId, isOptedOut) => {
  const optOutRequest = { brandId: brandId, optOutFlag: isOptedOut};
  const url = `/${hashedStudentId}/term/${termId}/`;
  let { data } = await optOutApi.put(url , optOutRequest);
  return data;
};

export const getStudentOptOut = async (hashedStudentId, termId, brandId) => {
  const params = { brandId: brandId };
  const url = `/${hashedStudentId}/term/${termId}/`;
  let { data } = await optOutApi.get(url, { params });
  return data;
};

export const isOptOutEnabled = async (brandId) => {
  const params = { brandId: brandId};
  const url = `/is-opt-out-enabled`;
  let { data } = await optOutApi.get(url, { params });
  return data;
};
